// Locale messages are NOT imported here: they are lazy-loaded per locale via
// the `file:` entries in nuxt.config.ts `i18n.locales`, so each visitor only
// downloads the active language instead of an eager both-languages bundle.
export default () => ({
	legacy: false,
	locale: "es",
	fallbackLocale: "es"
});
